import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import 'bootstrap';

(async () => {
    window.Alpine = Alpine;
    Alpine.plugin(collapse);

    await import('Packages/Application/Seven.Neos.NodeTypes/Resources/Private/Fusion/Main');
    await import('Packages/Application/Seven.Neos.CRM.Checkout/Resources/Private/Fusion/Main');
    await import('Packages/Application/Seven.Neos.CRM.Checkout.CheckoutForm/Resources/Private/Fusion/Main');
    await import('Packages/Application/Seven.Offerpage.Reviews/Resources/Private/Fusion/Main');

    Alpine.start();
})();